import { format } from "date-fns";
import { ptBR } from "date-fns/locale"; // Importa o idioma português do Brasil

/**
 * Retorna a data atual formatada no padrão brasileiro (ex: "4 de abril de 2026").
 * Utiliza a biblioteca date-fns e o locale pt-BR.
 *
 * @returns {string} A data formatada.
 */
export function obterDataAtualFormatada(): string {
    const dataAtual = new Date();

    // O formato "d 'de' MMMM 'de' yyyy" significa:
    // d    = dia do mês (1 a 31)
    // MMMM = nome do mês por extenso (janeiro, fevereiro...)
    // yyyy = ano com 4 dígitos
    // As aspas simples em 'de' servem para escapar a palavra e não ser tratada como formato
    return format(dataAtual, "d 'de' MMMM 'de' yyyy", { locale: ptBR });
}

// Exemplo de uso:
// console.log(obterDataAtualFormatada());
// Saída esperada: "4 de abril de 2026"
